// TODO: store language names in the translations file

export default {
    nl: 'Nederlands',
    en: 'English',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
};
